import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Downshift from 'downshift'

// API
import * as API  from '../../../utils/api'

class ReduxSchoolSearchInput extends Component {
  static propTypes = {
    // From Redux Form:
    // { input, label, type, meta: { touched, error } }

    //Optional
    error: PropTypes.string,
    meta: PropTypes.object,
    defaultInputValue: PropTypes.string,
  }

  state = {
    searching: false,
    schools: []
  }

  renderLabel(label) {
    const { disabled } = this.props;

    return label
    ? (
        <label className={disabled ? 'disabled' : null}>
          {label}
        </label>
      )
    : ''
  }

  getNameAttribute(item) {
    if (item.hasOwnProperty("school_name")) {
      return item.school_name
    } else {
      return item.name
    }
  }

  itemToString = (item) => {
    return item == null ? '' : String(this.getNameAttribute(item))
  }

  renderDropdown(schools, inputValue, getItemProps, highlightedIndex, selectedItem) {

    let dropdownInner = schools.length > 0 ?
    (
      schools.map((school, index) => (
        <div
          {...getItemProps({item: school})}
          key={school.id}
          className={`autocomplete-form-input-dropdown-item${highlightedIndex === index ? ' highlighted' : ''}${selectedItem === school ? ' selected' : ''}`}
        >
          {this.getNameAttribute(school)}
          <div className="location">
            {school.city}, {school.state}
          </div>
        </div>
      ))
    )
    : (
      <div
        className="autocomplete-form-input-dropdown-item no-results"
      >
        No Results
      </div>
    )

    return (
      <div
        className="autocomplete-form-input-dropdown"
      >
        {dropdownInner}
      </div>
    )
  }

  handleInputValueChange = (inputValue) => {
    if (inputValue) {
      this.setState({
         searching: true,
      }, () => this.updateSchoolOptions(inputValue))
    } else {
      this.setState(state => ({
        ...state,
        schools: []
      }))
    }
  }

  updateSchoolOptions = (query) => {
    API.searchSchools(query).then((schools) => {
      this.setState(state => ({
        ...state,
        searching: false,
        schools: schools.length > 0 ? schools : []
      }))
    })
  }

  getClasses() {
    const { searching } = this.state

    const { optionalClasses, meta: { touched, error }, } = this.props

    let classes = ''

    if (searching) {
      classes += ' searching'
    }

    if (optionalClasses) {
      classes += ' ' + optionalClasses
    }

    if (touched && error) {
      classes += ' error'
    }

    return classes
  }

  render() {
    const {
      input,
      label,
      meta: {
        touched,
        error
      },
      placeholder,
      defaultInputValue,
      defaultSelectedItem
    } = this.props

    const {
      schools,
    } = this.state

    return (
      <Downshift
        onChange={input.onChange}
        onInputValueChange={this.handleInputValueChange}
        itemToString={this.itemToString}
        defaultSelectedItem={defaultSelectedItem}
        defaultInputValue={defaultInputValue}
        key={ `school-search-${input.value}` }
        render={({
          getInputProps,
          getItemProps,
          isOpen,
          selectedItem,
          inputValue,
          highlightedIndex,
          defaultInputValue
        }) => (
          <div className={`autocomplete-form-input${this.getClasses()}`}>
            {this.renderLabel(label)}
            <div className="input-container">
              <input
                className={`${isOpen ? ' dropdown-active' : ''}`}
                {...getInputProps({
                  placeholder: placeholder ? placeholder : 'Type to Search for a School...',
                  type: 'text'
                })}
              />
            </div>
            {isOpen &&
              this.renderDropdown(schools, inputValue, getItemProps, highlightedIndex, selectedItem)
            }
            {touched && error &&
              <div className="input-error-message">
                {error}
              </div>
            }
          </div>
        )}
      />
    )
  }
}

export default ReduxSchoolSearchInput



// WEBPACK FOOTER //
// ./src/components/Global/ReduxForms/ReduxSchoolSearchInput.js